export const CANVAS = "canvas";
export const EXTERNAL = "external";
export const QUALITATIVE = "qualitative";
export const EMBEDDED = "embedded";

const emailVerification = (email) => {
  if (/\S+@\S+\.\S+/.test(email)) {
    return true;
  } else {
    return false;
  }
};

export default emailVerification;
